<script lang="ts">
  import { fly } from "svelte/transition";
  import { tweened } from "svelte/motion";
  import { cubicInOut, linear } from "svelte/easing";
  import TextNew from "../TextNew.svelte";
  import IconButton from "./IconButton.svelte";
  import { t } from "../../helpers/translations";

  const HOLD_TIME = 1500;
  const CANCEL_DURATION = 150;
  const INTERVAL = 10;

  export let onClick: () => void;
  let showAction: boolean = false;
  let containerStyle: string = "";
  let timer: number = 0;
  let interval: NodeJS.Timeout | null = null;
  let progressWidth = tweened(0);

  function onFocus(event: MouseEvent) {
    showAction = true;
  }

  function onLoseFocus() {
    cancelProgress();
    showAction = false;
  }

  function onMouseDown() {
    interval = setInterval(async () => {
      timer += INTERVAL;
      if (timer >= HOLD_TIME) {
        resetTimer();
        showAction = false;
        onClick();
        return;
      }

      // hacked width - not sure how to get border-box to be respected with absolute width element
      await progressWidth.set((timer / HOLD_TIME) * 97, { duration: 1, easing: linear });
    }, INTERVAL);
  }

  function onMouseUp() {
    cancelProgress();
  }

  function cancelProgress() {
    resetTimer();
    progressWidth.set(0, { duration: CANCEL_DURATION, delay: 50, easing: cubicInOut });
  }

  function resetTimer() {
    timer = 0;
    if (interval !== null) {
      clearInterval(interval);
      interval = null;
    }
  }

  $: progressStyle = `width: ${$progressWidth}%`;
</script>

<div
  class="container"
  on:mouseenter={onFocus}
  on:mouseleave={onLoseFocus}
  on:mousedown={onMouseDown}
  on:mouseup={onMouseUp}
  role="button"
  tabindex="0"
>
  <IconButton name="unlink" highlighted={showAction} />
  {#if showAction}
    <div
      class="progress-container"
      role="button"
      tabindex="0"
      style={containerStyle}
      transition:fly|global={{ y: "-8px", duration: 150, easing: cubicInOut }}
    >
      <div class="progress-text">
        <TextNew size="xs" --rk-text-color="var(--rk-text-error)"
          >{t("transaction.unlink.cta")}</TextNew
        >
      </div>
      <div class="progress-bar" style={progressStyle} />
    </div>
  {/if}
</div>

<style>
  .progress-container {
    position: fixed;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    transform: translateX(-75px);
    padding: 12px;
    width: 192px;
    height: 48px;
    background-color: var(--rekki-light);
    z-index: 99;
    /* pointer-events: none; */
    border-radius: 8px;
    box-shadow: 0px 8px 24px 0px #1f22261f;
    box-sizing: border-box;
    overflow: hidden;
    border: solid 1px #0000001a;
  }

  .progress-bar {
    position: absolute;
    top: 4px;
    left: 4px;
    bottom: 4px;
    background-color: #f8dcdc;
    border-radius: 4px;
  }

  .progress-text {
    z-index: 1;
  }
</style>
